import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const boardFocusStyleId = 'wb-v2-board-focus-theme';

export const boardFocusBridgeStyles = {
  'board-focus': {
    '--local-focus-bg': tokens.color.background.primary,
    '--local-focus-border': tokens.color.border.secondary,
    '--local-focus-card-hover-bg': tokens.color.background.secondary,
    '--local-focus-card-selected-bg': tokens.color.background.tertiary,
    '--local-focus-card-selected-border': tokens.color.border.secondary,
    '--local-focus-empty-color': tokens.color.text.quaternary,
  },
};
